class TableGridTextExtendedCellController {
  constructor() {
    this.name = 'tableGridTextExtendedCell';
  }

  getExtendedValue(row, extendedConfig) {
    return extendedConfig.value(row);
  }

  getIconStructure(row, extendedConfig) {
    return extendedConfig.icon? extendedConfig.icon(row) : false;
  }
  getAdditionalClass(row, extendedConfig) {
    return extendedConfig.class? extendedConfig.class(row) : '';
  }
}

export default TableGridTextExtendedCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridTextExtendedCell/tableGridTextExtendedCell.controller.js